/* eslint-enable @typescript-eslint/restrict-template-expressions */
import {useState, useEffect} from 'react';

interface TProps {
	value: string;
	title: string;
	icon: string;
	color: string;
}

const CardInfo = ({
	value,
	title,
	icon = 'calendar',
	color = 'primary',
}: TProps) => {
	const [cardClass, setCardClass] = useState('');
	const [titleClass, setTitleClass] = useState('');

	useEffect(() => {
		setCardClass(`card border-left-${color} shadow h-100 py-2`);
		setTitleClass(`text-xs font-weight-bold text-${color} text-uppercase mb-1`);
	}, [color]);

	return (
		<div data-testid="card-info" className="col-xl-3 col-md-6 mb-4">
			<div className={cardClass}>
				<div className="card-body">
					<div className="row no-gutters align-items-center">
						<div className="col mr-2">
							<div className={titleClass}>{title}</div>
							<div className="h5 mb-0 font-weight-bold text-gray-800">
								{value}
							</div>
						</div>
						<div className="col-auto">
							<i className={`fas fa-${icon} fa-2x text-gray-300`} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CardInfo;
